import { render, staticRenderFns } from "./AiDiagnosis.vue?vue&type=template&id=26bbc8fc&scoped=true&"
import script from "./AiDiagnosis.vue?vue&type=script&lang=js&"
export * from "./AiDiagnosis.vue?vue&type=script&lang=js&"
import style0 from "./AiDiagnosis.vue?vue&type=style&index=0&id=26bbc8fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26bbc8fc",
  null
  
)

export default component.exports